import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "7aec2ef4-efaf-47fd-9993-22979c55ecdf",
  publicId: "13",
  name: "Single speaker and multi-speaker environments",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
